import React from "react";
import { Collapse, Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useAppSelector } from "../../app/hooks";
import { resetMessageList } from "../MainContent/MainContentUtils";

/* Functional component properties */
interface Props {
  classes: any;
  item: any;
}

/* React Functional component */
export const TransitionAlert: React.FC<Props> = ({
  /* Function arguments (Props) */
  classes,
  item,
}): JSX.Element => {
  /* get state */
  const state = useAppSelector((state) => state);

  const [open, setOpen] = React.useState(true);

  return (
    <Collapse in={open}>
      <Alert
        variant="outlined"
        severity={(() => {
          switch (item.severity) {
            case 5:
              return "success";
            case 10:
              return "info";
            case 15:
              return "warning";
            case 20:
              return "error";
            case 30:
              return "error";
            case 40:
              return "error";
          }
        })()}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              setOpen(false);
              resetMessageList();
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {" "}
        {item.text === "Entry Required" &&
        item.fields &&
        state.mainContent.fieldList &&
        state.mainContent.fieldList.find(
          (elem) => elem.name.search(item.fields[0]) === 0
        ) !== undefined
          ? item.text +
            " - " +
            state.mainContent.fieldList.find(
              (elem) => elem.name.search(item.fields[0]) === 0
            )!.label
          : item.text}
      </Alert>
    </Collapse>
  );
};
